import { fromEvent, map, withLatestFrom, zipWith } from "rxjs";
import { isNotNullOrUndefined } from "./rxjs.helper";

export const a = 1;

export enum Swipe {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  UP = "UP",
  DOWN = "DOWN",
}

function isHorizontalSwipe(
  touchstart: TouchEvent,
  touchmove: TouchEvent,
): Swipe.RIGHT | Swipe.LEFT | null {
  const xDiff = touchstart.touches[0].clientX - touchmove.touches[0].clientX;

  if (
    Math.abs(xDiff) > 0.3 * document.body.clientWidth &&
    touchstart.timeStamp <= touchmove.timeStamp
  ) {
    return xDiff > 0 ? Swipe.RIGHT : Swipe.LEFT;
  }
  return null;
}

function isVerticalSwipe(
  touchstart: TouchEvent,
  touchmove: TouchEvent,
): Swipe.UP | Swipe.DOWN | null {
  const yDiff = touchstart.touches[0].clientY - touchmove.touches[0].clientY;

  if (
    Math.abs(yDiff) > 0.3 * document.body.clientWidth &&
    touchstart.timeStamp <= touchmove.timeStamp
  ) {
    return yDiff > 0 ? Swipe.UP : Swipe.DOWN;
  }
  return null;
}

export const watchSwipeEvents$ = fromEvent<TouchEvent>(document, "touchstart").pipe(
  // x swipe will prevail over y swipe
  zipWith(
    fromEvent<TouchEvent>(document, "touchend").pipe(
      withLatestFrom(fromEvent<TouchEvent>(document, "touchmove")),
    ),
  ),
  map(([tStart, [, tMove]]) => {
    return isHorizontalSwipe(tStart, tMove) || isVerticalSwipe(tStart, tMove);
  }),
  isNotNullOrUndefined(),
);

export const watchHorizontalSwipeEvents$ = fromEvent<TouchEvent>(document, "touchstart").pipe(
  zipWith(
    fromEvent<TouchEvent>(document, "touchend").pipe(
      withLatestFrom(fromEvent<TouchEvent>(document, "touchmove")),
    ),
  ),
  map(([tStart, [, tMove]]) => {
    return isHorizontalSwipe(tStart, tMove);
  }),
  isNotNullOrUndefined(),
);

export const watchVerticalSwipeEvents$ = fromEvent<TouchEvent>(document, "touchstart").pipe(
  zipWith(
    fromEvent<TouchEvent>(document, "touchend").pipe(
      withLatestFrom(fromEvent<TouchEvent>(document, "touchmove")),
    ),
  ),
  map(([tStart, [, tMove]]) => {
    return isVerticalSwipe(tStart, tMove);
  }),
  isNotNullOrUndefined(),
);
